import * as React from "react";

import { Stack, Typography } from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom";

import ContentEnglish from "../../Components/organisms/PrivacyPolicy/ContentEnglish";
import ContentSpanish from "../../Components/organisms/PrivacyPolicy/ContentSpanish";
import ContentSinhala from "../../Components/organisms/PrivacyPolicy/ContentSinhala";
import ContentTamil from "../../Components/organisms/PrivacyPolicy/ContentTamil";

const PrivacyPolicy = () => {
  const [lang, setLang] = React.useState("");
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const languageSetter = () => {
    if (location?.search.includes("es")) {
      setLang("es");
    } 
    else if (location?.search.includes("sn")){
      setLang("sn");
    }
    else if (location?.search.includes("tml")){
      setLang("tml");
    }
    else {
      setLang("en");
    }
  };

  React.useEffect(() => {
    languageSetter();
  }, [searchParams]);

  return (
    <Stack direction={"column"}>
      <Typography>
        {lang == "es" ? (
          <>
            <ContentSpanish />
          </>
        ) : 
        lang == "sn" ? (
          <ContentSinhala/>
        ): 
        lang == "tml" ? (
          <ContentTamil/>
        ): 
        (
          <>
            <ContentEnglish />
          </>
        )}
      </Typography>
    </Stack>
  );
};

export default PrivacyPolicy;
